import { ProductForm } from 'components/goods/ProductForm/ProductForm'

export const GoodsAdd: React.FC = () => {
  return <ProductForm mode='create' />
}
